/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Launch_BadgeInputs */

const es_landing_price_launch_badge = /** @type {(inputs: Landing_Price_Launch_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta de lanzamiento`)
};

const gl_landing_price_launch_badge = /** @type {(inputs: Landing_Price_Launch_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta de lanzamento`)
};

const en_landing_price_launch_badge = /** @type {(inputs: Landing_Price_Launch_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch offer`)
};

/**
* | output |
* | --- |
* | "Launch offer" |
*
* @param {Landing_Price_Launch_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_launch_badge = /** @type {((inputs?: Landing_Price_Launch_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Launch_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_launch_badge(inputs)
	if (locale === "en") return en_landing_price_launch_badge(inputs)
	return es_landing_price_launch_badge(inputs)
});